import styled from '@emotion/styled';

export const SnackbarStyles = styled.div`
    .notistack-SnackbarContainer {
        width:75%;

        > div {
            width: 100%;
        }

        .notification {
            padding: 20px 20px 20px 60px;

            > omni-icon {
                width: 20px;
                height: 20px;
                top: 21px;
                left: 18px;
            }
           
        }
    }
     .notistack-SnackbarContainer {
     .notification.is-warning {
        // width:42.8571428571rem;
            display: flex;
            align-items: center;
            position: relative;
            > omni-icon {
                width: 20px;
                height: 20px;
                top: 38px;
                left: 18px;
            }
             omni-icon.warning-close {
                position: absolute !important;
                top: 0.8571428571rem;
                right: 1.2857142857rem;
                left:inherit !important;
                width: 27px;
                height: 27px;
                cursor:pointer !important;
}
            &.is-warning {
                padding: 36px 40px 30px 46px !important;
                background:  #fed882 !important;
                
                
            }
            
        
}
    }
`;
